import authentication from "@/store/modules/authentication";
import azure from "@/store/modules/azure";
import arctitan from "@/store/modules/arctitan";
import pageMeta from "@/store/modules/pageMeta";
import users from "@/store/modules/users";
import organisations from "@/store/modules/organisations";
import arcTitan from "@/modules/ArcTitan/store/arcTitan";
import dropDown from "./dropDown";
import branding from "./branding";

export default {
  authentication,
  azure,
  arctitan,
  pageMeta,
  users,
  organisations,
  arcTitan,
  dropDown,
  branding,
};
